<mat-accordion>
  <mat-expansion-panel class="mat-elevation-z0" [expanded]="toggleOnInitialize" hideToggle="true">
    <mat-expansion-panel-header class="disable_ripple">
      <mat-panel-title>
        <div
          class="title"
          *ngIf="!inMultiSelect"
          (click)="click()"
          [ngClass]="{
            'title-single-page': inSinglePage,
            'bold-title': boldTitle,
          }"
        >
          <mat-icon class="icon">{{ expandToggle ? 'keyboard_arrow_down' : 'chevron_right' }}</mat-icon>
          <div class="title-text" *ngIf="!isLink">
            {{ withLabelPipe ? (accordionTitle | labelsProvider) : accordionTitle }}
          </div>
          @if (isLink) {
            <app-anchor-link [navigation]="linkUrl" class="title-text title-link">
              {{ withLabelPipe ? (accordionTitle | labelsProvider) : accordionTitle }}
            </app-anchor-link>
          }
        </div>

        <div
          class="title multi-select"
          *ngIf="inMultiSelect"
          (click)="click()"
          [ngClass]="{
            'title-single-page': inSinglePage,
            'bold-title': boldTitle,
            'selected-title': selectionIndication,
          }"
        >
          <div class="title-text">
            <div>
              {{ withLabelPipe ? (accordionTitle | labelsProvider) : accordionTitle }}
            </div>

            <span *ngIf="selectedCount > 0" class="selected-count">
              {{ selectedCount === 1 ? '(1 rule was selected)' : '(' + selectedCount + ' rules were selected)' }}
            </span>

            <div class="new-feature" *ngIf="isNewFeature">
              <img src="assets/images/notifications/new.svg" class="new-img" alt="filter" />
              <div>NEW</div>
            </div>
          </div>
          <mat-icon class="icon">{{ expandToggle ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-content></ng-content>
  </mat-expansion-panel>
</mat-accordion>
